
import {
  computed, defineComponent, onMounted, ref,
} from 'vue';
import { useRouter } from 'vue-router';
// eslint-disable-next-line import/no-cycle
import { useMainStore } from '@/store/mainStore';
// eslint-disable-next-line import/no-cycle
import { useDriveStore } from '@/modules/drive/store/driveStore';
import { lowResUrlByUrl } from '@/helpers/lowResPhotoUrl';
import {
  APPLICATION_SETTINGS_TYPE,
  ACCOUNT_STATUS,
  PERFORMANCE_MONITORING_STEPS,
  PHOTO_SIZES,
} from '@/types/enums';
// eslint-disable-next-line import/no-cycle
import MonitoringService from '@/services/MonitoringService';
import UsePullToRefresh from '@/composables/UsePullToRefresh';
import AppHeader from '@/components/AppHeader.vue';
import LoginRegistrationLink from '@/modules/welcome/components/LoginRegistrationLink.vue';
import AppUploadControls from '@/components/AppUploadControls.vue';
import AppLoader from '@/components/UI/AppLoader.vue';
import AppSearch from '@/components/UI/AppSearch.vue';
import CasesItems from '@/modules/drive/components/DriveItems.vue';
import AppBadge from '@/components/AppBadge.vue';
// import CasesPublicItems from '@/modules/drive/components/DrivePublicItems.vue';
import AppClueTooltip from '@/components/UI/AppClueTooltip.vue';

export default defineComponent({
  components: {
    AppClueTooltip,
    AppHeader,
    LoginRegistrationLink,
    AppUploadControls,
    AppLoader,
    AppSearch,
    CasesItems,
    AppBadge,
    // CasesPublicItems,
  },
  setup() {
    const router = useRouter();
    const mainStore = useMainStore();
    const driveStore = useDriveStore();

    function refreshDrive() {
      driveStore.photos.page = 0;
      driveStore.photos.lastPage = -1;

      driveStore.cases.page = 0;
      driveStore.cases.lastPage = -1;

      driveStore.publicCases.page = 0;
      driveStore.publicCases.lastPage = -1;

      driveStore.mixedData.page = 0;
      driveStore.mixedData.lastPage = -1;

      return Promise.all([
        driveStore.fetchCases(),
        driveStore.fetchPhotos(),
        driveStore.fetchMixedData(),
        driveStore.fetchPublicCases(),
      ]);
    }

    const isPublicCases = computed(
      () => mainStore.applicationSettings.find((feature) => feature.name === APPLICATION_SETTINGS_TYPE.SHOW_PUBLIC_CASES_FEED)?.enabled,
    );

    const {
      loadingPull, loosingText, successText, pullingText, loadingText, onRefresh,
    } = UsePullToRefresh(refreshDrive);

    const searchValue = ref<string>('');
    const isDataLoading = ref<boolean>(false);
    const scrollItem = ref<HTMLDivElement | null>(null);

    const skeletons = ref(false);
    const skeletonsNetwork = ref(false);

    const isAuth = computed(() => !!(mainStore.user.accountId) && mainStore.user.accountStatuses.includes(ACCOUNT_STATUS.PHONE_NUMBER_CONFIRMED));
    const fullName = computed(() => `${mainStore.user.firstName} ${mainStore.user.lastName}`);

    const photoUrl = computed(() => {
      if (mainStore.user.photo?.url) {
        return lowResUrlByUrl(mainStore.user.photo.url, PHOTO_SIZES.SM);
      }
      // eslint-disable-next-line global-require
      return require('@/assets/img/mockup/profile.svg');
    });

    function navigateTo(rout: string) {
      router.push(rout);
    }

    let timeout: ReturnType<typeof setTimeout>;
    function navigateToDrive() {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        router.push(`/drive?search=${searchValue.value}`);
      }, 600);
    }
    function logOut() {
      mainStore.logout().then((response) => {
        if (response.success) {
          router.push('/');
        }
      });
    }

    function sendPerformanceAnalitics() {
      if (MonitoringService.isFirstPageMonitored) {
        MonitoringService.sendPageMountedSpeed();
      } else {
        MonitoringService.isFirstPageMonitored = true;
        MonitoringService.sendMonitoringStep(PERFORMANCE_MONITORING_STEPS.FIRST_PAGE_MOUNTED_WELCOME, performance.now());
      }
    }
    function scrollToBottom(): void {
      setTimeout(() => {
        if (scrollItem.value) {
          const pos = scrollItem.value?.getBoundingClientRect();
          const elMain = document.querySelector('.el-main');
          if (elMain) {
            elMain.scrollTo(pos.x, pos.y);
          }
        }
      }, 100);
    }

    onMounted(() => {
      if (!mainStore.isMobile) {
        router.push('/drive');
      }
      sendPerformanceAnalitics();
    });

    return {
      isAuth,
      isDataLoading,
      fullName,
      photoUrl,
      searchValue,
      mainStore,
      logOut,
      navigateTo,
      navigateToDrive,
      driveStore,
      skeletons,
      skeletonsNetwork,

      loadingPull,
      loosingText,
      successText,
      pullingText,
      loadingText,
      onRefresh,
      isPublicCases,
      scrollItem,
      scrollToBottom,
    };
  },
});
